<template>
  <router-link class="treeview" tag="li" v-if="router && router.name" :to="router">
    <a href="#">
      <div><img :class="icon" /></div>
      <span class="side-parent">{{ name }}</span>     
    </a>  
  </router-link>  
  <li  :class="getType" v-else>
    {{ isHeader ? name : '' }}
    <a href="#">
      <div><img :class="icon" /></div><span class="side-sub">{{ name }}</span>
    </a>
    <ul id="treeMenu" class="treeview-menu" v-if="items.length > 0" style="width: 250px">
      <router-link tag="li" v-for="(item,index) in items" :data="item" :key="index" :to="item.router" v-if="item.router && item.router.name">
        <a v-if="window.width < 450">
          <div class="sub-menu">{{ item.name | abbreviation }}</div> 
        </a>
        <a v-else>
          <div class="sub-menu"><img style="width:32px;" :class="icon" /> <div class="sub-menu-label">{{ item.name }}</div></div> 
        </a>        
      </router-link>
      <li v-else>
        <a>
          <div  class="sub-menu"><img style="width:32px;" :class="icon" /><div class="sub-menu-label">{{ item.name }}</div></div> 
        </a>
      </li>
      <li v-if="window.width > 450" class="li-end"></li>
    </ul>
  </li>
</template>

<script>
export default {
  name: 'va-slide-orange-item',
  data () {
    return {
      window: {
        width: 0,
        height: 0
      }
    }
  },
  props: {
    type: {
      type: String,
      default: 'item'
    },
    isHeader: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    name: {
      type: String
    },
    badge: {
      type: Object,
      default () {
        return {}
      }
    },
    items: {
      type: Array,
      default () {
        return []
      }
    },
    router: {
      type: Object,
      default () {
        return {
          name: ''
        }
      }
    },
    link: {
      type: String,
      default: ''
    }
  },
  created () {
  },
  mounted () {
    $('.treeview').click(function () {
      var thisMenu = $(this).children('.treeview-menu')
      $('.treeview-menu').each(function () {
        if (thisMenu.filter(function (element) { return element === $(this) }).length) {
          return
        }
        $(this).css('display', '')
      })
    })

    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  methods: {
    handleResize () {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
    }
  },
  filters: {
    abbreviation: function (value) {
      if (!value) return ''
      let word = value.split(' ')
      let resul = ''
      if (word.length === 1) {
        resul = word[0].substring(0, 2).toUpperCase()
      } else {
        let count = 0
        for (let i = 0; i < word.length; i++) {
          if (count > 1) {
            break
          }
          if (word[i].toLowerCase() !== 'de') {
            resul = resul + word[i].substring(0, 1).toUpperCase()
            count++
          }
        }
      }
      return resul
    }
  },
  computed: {
    getType () {
      if (this.isHeader) {
        return 'header treeview'
      }
      return this.type === 'item' ? '' : 'treeview'
    }
  }
}
</script>
<style>

.sidebar-mini.sidebar-collapse .sidebar-menu>li
{
  padding-bottom: 15px;
}

.sidebar-mini.sidebar-collapse .sidebar-menu>li>a {
  height: 36px;
}

.sidebar-mini.sidebar-collapse .sidebar-menu>li>a:hover {
    background: #ffffff !important;
}

.sidebar-mini.sidebar-collapse .sidebar-menu>li>a>div:hover {
  background: rgba(0, 157, 0, 0.1);
  border-radius: 8px;  
  height: 36px;
}

.sidebar-mini.sidebar-collapse .sidebar-menu>li>a>div>img:hover {
  filter: brightness(0) saturate(100%) invert(37%) sepia(98%) saturate(2005%) hue-rotate(92deg) brightness(91%) contrast(109%);
}

.skin-green .sidebar-menu>li:hover>a
{
  background: #ffffff !important;
}

.skin-green .sidebar-menu>li:hover>a>div
{
  background: rgba(0, 157, 0, 0.1);
  border-radius: 8px;  
  height: 36px;
}

.skin-green .sidebar-menu>li:hover>a>div>img
{
  filter: brightness(0) saturate(100%) invert(37%) sepia(98%) saturate(2005%) hue-rotate(92deg) brightness(91%) contrast(109%);
}

.skin-green .sidebar-menu>li>a:hover{
  background: #009d00 !important;
}

.sidebar-mini:not(.sidebar-mini-expand-feature).sidebar-collapse .sidebar-menu>li:hover>a>span{
  padding: 8px 5px 8px 5px !important;
}

.sidebar-menu>li>a{
  padding: 0px 5px;
}

.sidebar-menu>li>a>div{
  padding: 6px 0px;
}

.sidebar-menu>li>a>div>img{
  width: 32px;
}

.side-parent
{
  width:228px !important; 
  /*background:rgba(255, 120, 0, 0.1) !important; */
  background-color: #183764 !important;
  left: 70px !important;
  border-radius: 8px;
  color: white;
}

.side-sub{
  width:228px !important; 
  background:#183764 !important;
  left: 70px !important;
  border-top-left-radius: 8px !important;
  border-top-right-radius: 8px !important;
  color: white;
}


.li-end{  
  position: relative;
  height: 10px;
  left: 15px !important;
  right: 5px;
  bottom: 5px;
  background:white;
  width: 228px !important;
  border-left: 1px solid #183764;
  border-right: 1px solid #183764;
  border-bottom: 1px solid #183764;
  border-bottom-left-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
} 

.sub-menu{
  display: flex;
  height: 35px;
  align-items: center;  
}

.sub-menu-label{
  padding-left: 10px;
  padding-top: 5px;
  color:#183764
}


.treeview-menu>li{  
  position: relative;
  left: 15px !important;
  right: 5px;
  bottom: 5px;
  background:white;
  width: 228px !important;
  border-left: 1px solid #183764;
  border-right: 1px solid #183764;
} 

.treeview-menu>li:hover {
  background: #CFFFCF !important;   
  color:#183764;  
}

.treeview-menu{
  background: none !important;
}

#treeMenu{
  background:none!important;
}

.headerTree-a{
  background-color: #183764 !important;
}

.skin-green .sidebar-menu>li.menu-open>a
{
    background: #fff;
    border-left: 2px solid #183764;  
}

.skin-green .sidebar-menu>li.menu-open>a>div
{
  background: rgba(0, 157, 0, 0.1);
  border-radius: 8px;  
  height: 36px;
}


.skin-green .sidebar-menu>li.menu-open>a>div>img
{
  filter: brightness(0) saturate(100%) invert(37%) sepia(98%) saturate(2005%) hue-rotate(92deg) brightness(91%) contrast(109%);
}

.skin-green .sidebar-menu>li.menu-open>ul>li
{
  left:14px !important
}

.treeview-menu>li>a
{
  padding: 5px;
}

@media (min-width: 768px)
{
  .sidebar-mini:not(.sidebar-mini-expand-feature).sidebar-collapse .sidebar-menu>li:hover>.treeview-menu {
    top: 36px;    
  }

  .sidebar-mini:not(.sidebar-mini-expand-feature).sidebar-collapse .sidebar-menu>li:hover>a>span{
    margin-left: -21px;
  }

  .sidebar-mini:not(.sidebar-mini-expand-feature).sidebar-collapse .sidebar-menu>li:hover>.treeview-menu {
    left:32px;
  }
}

@media screen and (max-width: 414px) {
  .treeview-menu
  {
    margin-top: 10px !important;
    padding-left: 0px;
  }
  .treeview-menu>li
  {
    border: 0px;
    width: 30px !important;
  }

  .skin-green .sidebar-menu .treeview-menu>li.active>a
  {
    margin-left: -17px;
  }

  .skin-green .sidebar-menu .treeview-menu>li>a
  {
    margin-left: -20px;
  }

  .sub-menu
  {
    color: #183764;
    width: 42px;
    padding-left: 15px;    
  }
}
</style>



// WEBPACK FOOTER //
// VASlideOrangeItem.vue?f8baae6c